import RecipesService from 'services/recipes';

const bookmarkRecipe = async (recipeID, bookmarked) => {
  if (!recipeID) throw new Error('recipeID cannot be empty');

  await RecipesService.bookmark(recipeID, bookmarked);
};

export default bookmarkRecipe;
